export const REQUEST_ADDTOCART_ITEM="Request_AddToCart_Item";
export const SUCCESS_ADDTOCART_ITEM="Success_AddToCart_Item";
export const FAILURE_ADDTOCART_ITEM="Failure_AddToCart_Item";

export const REQUEST_CART_ITEMS="Request_Cart_Items";
export const SUCCESS_CART_ITEMS="Success_Cart_Items";
export const FAILURE_CART_ITEMS="Failure_Cart_Items";

export const REQUEST_DELETE_CART_ITEMS="Request_Delete_Cart_Items";
export const SUCCESS_DELETE_CART_ITEMS="Success_Delete_Cart_Items";
export const FAILURE_DELETE_CART_ITEMS="Failure_Delete_Cart_Items";